export default __webpack_public_path__ + "static/media/Logo_Princeton University.1fa32c94.png";